import { render, staticRenderFns } from "./CollectionCardSkeleton.vue?vue&type=template&id=796c309c&scoped=true"
import script from "./CollectionCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CollectionCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CollectionCardSkeleton.vue?vue&type=style&index=0&id=796c309c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c309c",
  null
  
)

export default component.exports